/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/variable-1784383': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M8 19a3 3 0 01-3-3V8a3 3 0 013-3 1 1 0 000-2 5 5 0 00-5 5v8a5 5 0 005 5 1 1 0 000-2zm7.71-3.29a1 1 0 000-1.42L13.41 12l2.3-2.29a1 1 0 00-1.42-1.42L12 10.59l-2.29-2.3a1 1 0 00-1.42 1.42l2.3 2.29-2.3 2.29a1 1 0 000 1.42 1 1 0 001.42 0l2.29-2.3 2.29 2.3a1 1 0 001.42 0zM16 3a1 1 0 000 2 3 3 0 013 3v8a3 3 0 01-3 3 1 1 0 000 2 5 5 0 005-5V8a5 5 0 00-5-5z"/>'
  }
})
